import { createApp } from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { createVuetify } from 'vuetify';
import { createPinia } from 'pinia';
import { ROBCO_THEME } from '@therobotcompany/robco-frontend-library';
import gettext from '@/i18n/gettext';
import App from '@/App.vue';
import router from '@/router';

import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/lib/styles/main.sass';
import '@/styles/_global.scss';

const vuetify = createVuetify({
  theme: {
    defaultTheme: 'robcoTheme',
    themes: {
      robcoTheme: ROBCO_THEME,
    },
  },
});

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(vuetify);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
app.use(gettext as any);
app.use(VueAxios, axios);
app.provide('axios', app.config.globalProperties.axios);

app.mount('#app');
